import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	Stack
} from '@mui/material';
import React from 'react';
import { IFlowInteractionGroup } from 'types/flows';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ActionTypeIcon from './ActionTypeIcon';
import ActionOutputLabel from './ActionOutputLabel';

const ActionOutputBlockGroup = ({
	interactionGroup
}: {
	interactionGroup: IFlowInteractionGroup;
}) => (
	<Accordion
		data-testid="interaction-group-accordion"
		sx={{
			width: '100%',
			boxShadow: 'none',
			backgroundColor: 'transparent',
			backgroundImage: 'none',
			'&.Mui-expanded': { m: 0 }
		}}
	>
		<AccordionSummary
			expandIcon={<ExpandMoreIcon />}
			aria-controls="panel1a-content"
			id="panel1a-header"
			sx={{
				flexDirection: 'row-reverse',
				pl: 1.5,
				minHeight: 52,
				'&.Mui-expanded': { minHeight: 52 },
				'.Mui-expanded': { my: '16px !important' }
			}}
		>
			<Box pl={0.5}>
				<ActionOutputLabel
					interaction={interactionGroup}
					label={interactionGroup.label}
				/>
			</Box>
		</AccordionSummary>
		<AccordionDetails sx={{ pt: 0 }}>
			<Stack direction="column" data-testid="interaction-group-stack">
				{interactionGroup.interactions.map((innerInteraction) => (
					<Box
						display="flex"
						flexGrow={1}
						py={1}
						flexDirection="row"
						alignItems="center"
						overflow="hidden"
						key={innerInteraction.id}
					>
						<Box
							width={28}
							alignItems="center"
							display="flex"
							justifyContent="center"
						>
							<ActionTypeIcon
								actionType={innerInteraction.icon || innerInteraction.type}
							/>
						</Box>
						<Box pl={0.5}>
							<ActionOutputLabel
								interaction={innerInteraction}
								label={innerInteraction.label}
							/>
						</Box>
					</Box>
				))}
			</Stack>
		</AccordionDetails>
	</Accordion>
);

export default ActionOutputBlockGroup;
